import { Header } from "antd/es/layout/layout";
import React from "react";
import './cms-header.css';
import { getImageUrl } from "../../../utils/image-helper/get-image-url";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { logout } from "../../../redux/reducer/session.reducer";
import { Link, useNavigate } from "react-router-dom";

export const CMSHeader = () => {
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.session.user);
    const navigate = useNavigate();
    const handleLogoutClick = () => {
        if (window.confirm('Biztosan kijelentkezel?')) {
            dispatch(logout());
            navigate('/cms/login');
        }
    };

    return (
        <Header className="cms-header">
            <div className="title">
                <img src={getImageUrl('holoverzum-icon-white.png')} alt="holoverzum-icon-white" />
                &nbsp;
                Holoverzum
            </div>
            <div className="account-links">
                <img src={getImageUrl('question-icon.png')} alt="question-icon" />
                &nbsp;&nbsp;
                <Link to={'/cms/users/profile'}>
                    <img src={getImageUrl('profile-icon.png')} alt="profile-icon" />
                </Link>
                &nbsp;&nbsp;
                <span>{ user?.name ? user.name : user?.email }</span>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <img src={getImageUrl('logout-icon.png')} alt="logout-icon" onClick={handleLogoutClick} />
            </div>
        </Header>
    );
};